import { ChangeDetectorRef, Directive, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { InternalService } from '../root/internal.service';

@Directive({
  selector: '[lohiInternal]',
})
export class InternalDirective implements OnDestroy {
  private subscription: Subscription;
  private hasView = false;

  constructor(
    private internalService: InternalService,
    private cd: ChangeDetectorRef,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
    this.setup();
  }

  public ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setup() {
    this.subscription = this.internalService.isInternal$.subscribe((isInternal) => {
      if (!isInternal) {
        if (this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
          this.cd.markForCheck();
        }
      } else {
        if (!this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
          this.cd.markForCheck();
        }
      }
    });
  }
}
